module.exports = __webpack_public_path__ + "img/hud-06.bd4c68fe.png";